import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import BannerMessage from '../../banner-message';
import GridColumns from '../../grid-columns';
import ToggleIcon from '../../toggle-icon';
import FeaturePropType from '../../../utils/prop-types/feature';
import { mapFeaturesToCategory } from './helpers';

class AmenitiesViewContent extends React.Component {
  static propTypes = {
    features: PropTypes.arrayOf(FeaturePropType).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      groupedFeatures: mapFeaturesToCategory(props.features),
    };
  }

  componentDidUpdate = (prevProps) => {
    const { features } = this.props;
    if (!_.isEqual(prevProps.features, features)) {
      const groupedFeatures = mapFeaturesToCategory(features);
      this.setState(() => ({ groupedFeatures }));
    }
  }

  render = () => {
    const { groupedFeatures } = this.state;
    const totalFeatures = Object.keys(groupedFeatures).reduce((result, groupName) => result.concat(groupedFeatures[groupName]), []);

    return (
      <div>
        {(!totalFeatures || !totalFeatures.length) && <BannerMessage message="PLEASE UPDATE YOUR STATION AMENITIES" />}
        {
          (totalFeatures && !!totalFeatures.length)
            && (
              <GridColumns contents={
                Object.keys(groupedFeatures).map(groupName => ({
                  title: `${groupName.charAt(0).toUpperCase()}${groupName.slice(1)} Amenities`,
                  body: (
                    !!groupedFeatures[groupName].length
                    && (
                      <div>
                        {groupedFeatures[groupName].map(feature => (
                          <ToggleIcon
                            key={feature.id}
                            value={feature.id}
                            name={feature.display_name}
                            imageName={feature.id}
                            imagePath="/images/stationProfile/v2/"
                          />
                        ))}
                      </div>
                    )
                  ),
                }))}
              />
            )
        }
      </div>
    );
  }
}

export default AmenitiesViewContent;
